/**
 * Returns a Safari compatible date string
 *
 * @see https://stackoverflow.com/questions/4310953/invalid-date-in-safari
 */
export default function toSafariCompatibleDateString(dateString) {
  return dateString?.trim?.().replace(/ /g, "T")
};
